import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Megaphone } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function PaidAdvertising() {
  usePageMeta({
    title: "קידום ממומן בגוגל: שירות ניהול קמפיינים לרווח מקסימלי | upsite",
    description: "קידום ממומן שיעזור לכם להשיג לידים איכותיים כבר מהיום הראשון. ניהול קמפיינים ממומנים בגוגל וברשתות החברתיות עם דגש על החזר השקעה (ROI) מקסימלי. לחצו לפרטים",
  });

  return (
    <ServicePageTemplate
      icon={Megaphone}
      title="קידום ממומן בגוגל וברשתות"
      subtitle="קידום ממומן"
      description="ניהול קמפיינים ממומנים בגוגל, פייסבוק ואינסטגרם עם מיקוד ב-ROI ותוצאות מדידות. אנחנו מביאים לידים איכותיים במחיר הנכון."
      image="/images/services/paid-advertising.jpeg"
      benefits={[
        "ניהול קמפיינים בגוגל אדס (Google Ads)",
        "פרסום ממוקד בפייסבוק ואינסטגרם",
        "אופטימיזציה שוטפת למקסום ROI",
        "דיווחים מפורטים ושקופים",
        "A/B Testing ושיפור מתמיד של מודעות",
        "ניהול תקציב חכם ויעיל",
      ]}
      processSteps={[
        { title: "הגדרת יעדים", desc: "הבנת היעדים העסקיים, קהל היעד והתקציב." },
        { title: "בניית קמפיינים", desc: "יצירת מודעות, הגדרת קהלים ובניית מבנה קמפיין אופטימלי." },
        { title: "ניהול ואופטימיזציה", desc: "מעקב יומי, אופטימיזציה של ביצועים ושיפור מתמיד." },
        { title: "דיווח וניתוח", desc: "דיווחים שבועיים/חודשיים עם תובנות ופעולות לשיפור." },
      ]}
    />
  );
}
